export async function captureScreen() {
  try {
    // Запрашиваем доступ к экрану
    const stream = await navigator.mediaDevices.getDisplayMedia({
      video: {
        width: { max: 1440 },
        height: { max: 900 },
      },
    });

    await sleep(1000);

    // Создаём видео-элемент, чтобы отобразить захваченное видео
    const video = document.createElement("video");
    video.srcObject = stream;
    await new Promise((resolve) => (video.onloadedmetadata = resolve));
    video.play();

    // Рисуем кадр на canvas
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Останавливаем захват экрана
    stream.getTracks().forEach((track) => track.stop());

    return canvas.toDataURL("image/png");
  } catch (err) {
    console.error("Ошибка захвата экрана:", err);
  }
}

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
